import React from 'react';
import TruncatedText from '@spark/ui-components/components/TanStackTable/components/TruncatedText';
import { Button } from '@spark/ui-components/components/Button';
import Icon from '@spark/ui-components/components/Icon';
import Tooltip from '@spark/ui-components/components/Tooltip';

/**
 * Colunas da tabela de viagens usando TanStack Table
 */
export const getViagensColumns = (handleEditar, handleExcluir) => [
  {
    id: 'codigoIntegracao',
    header: 'Código',
    accessorKey: 'codigoIntegracao',
    size: 120,
    enableSorting: true,
    cell: ({ getValue }) => <TruncatedText value={getValue()} maxLength={15} />
  },
  {
    id: 'numeroCarga',
    header: 'Número da Carga',
    accessorKey: 'numeroCarga',
    size: 140,
    enableSorting: true,
    cell: ({ getValue }) => <TruncatedText value={getValue()} maxLength={15} />
  },
  {
    id: 'nomeMotorista',
    header: 'Motorista',
    accessorKey: 'nomeMotorista',
    size: 150,
    enableSorting: true,
    cell: ({ getValue }) => <TruncatedText value={getValue()} maxLength={18} />
  },
  {
    id: 'numeroPlaca',
    header: 'Placa',
    accessorKey: 'numeroPlaca',
    size: 100,
    enableSorting: true,
    cell: ({ getValue }) => <span>{getValue()}</span>
  },
  {
    id: 'numeroFrota',
    header: 'Frota',
    accessorKey: 'numeroFrota',
    size: 100,
    enableSorting: true,
    cell: ({ getValue }) => <TruncatedText value={getValue()} maxLength={10} />
  },
  {
    id: 'origem',
    header: 'Origem',
    accessorKey: 'cidadeOrigem',
    size: 130,
    enableSorting: true,
    cell: ({ getValue, row }) => {
      const cidade = getValue();
      const uf = row.original.ufOrigem;
      const texto = uf ? `${cidade}/${uf}` : cidade;
      return <TruncatedText value={texto} maxLength={15} />;
    }
  },
  {
    id: 'destino',
    header: 'Destino',
    accessorKey: 'cidadeDestino',
    size: 130,
    enableSorting: true,
    cell: ({ getValue, row }) => {
      const cidade = getValue();
      const uf = row.original.ufDestino;
      const texto = uf ? `${cidade}/${uf}` : cidade;
      return <TruncatedText value={texto} maxLength={15} />;
    }
  },
  {
    id: 'dataInicio',
    header: 'Data Início',
    accessorKey: 'dataInicio',
    size: 110,
    enableSorting: true,
    cell: ({ getValue }) => <span>{getValue()}</span>
  },
  {
    id: 'dataFim',
    header: 'Data Fim',
    accessorKey: 'dataFim',
    size: 110,
    enableSorting: true,
    cell: ({ getValue }) => <span>{getValue()}</span>
  },
  {
    id: 'totalKmRodado',
    header: 'KM Rodado',
    accessorKey: 'totalKmRodado',
    size: 110,
    enableSorting: false,
    cell: ({ getValue }) => (
      <span style={{ fontWeight: 'bold', color: '#007bff' }}>
        {getValue()}
      </span>
    )
  },
  {
    id: 'valorFreteLiquido',
    header: 'Frete Líquido',
    accessorKey: 'valorFreteLiquido',
    size: 130,
    enableSorting: true,
    cell: ({ getValue }) => {
      const value = getValue();
      if (!value || value === 0) return <span>R$ 0,00</span>;
      return (
        <span style={{ fontWeight: '500', color: '#28a745' }}>
          {`R$ ${parseFloat(value).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
        </span>
      );
    }
  },
  {
    id: 'valorFreteBruto',
    header: 'Frete Bruto',
    accessorKey: 'valorFreteBruto',
    size: 130,
    enableSorting: true,
    cell: ({ getValue }) => {
      const value = getValue();
      if (!value || value === 0) return <span>R$ 0,00</span>;
      return (
        <span style={{ fontWeight: '500', color: '#007bff' }}>
          {`R$ ${parseFloat(value).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
        </span>
      );
    }
  },
  {
    id: 'notasFiscais',
    header: 'Notas Fiscais',
    accessorKey: 'notasFiscais',
    size: 160,
    enableSorting: false,
    cell: ({ getValue }) => (
      <Tooltip dir="top" text={getValue() || 'Nenhuma NF associada'}>
        <div style={{ cursor: 'pointer' }}>
          <TruncatedText value={getValue() || 'Nenhuma NF'} maxLength={20} />
        </div>
      </Tooltip>
    )
  }
];
